export const categories = [
	"Control & Output",
	"Drawing",
	"Data sources",
	"Google Maps",
	"Cloud",
	"Import/Export",
];

export const defaultCategory = categories[0];

export const settings = [
	{
		title: "Re-open windows on launch",
		name: "window_rememberer",
		help: "This will keep track of any windows you open and will re-open them next time you launch the app.",
		category: "Control & Output",
		type: "select",
		defaultSelected: false,
		options: [
			{
				label: "No",
				value: true,
			},
			{
				label: "Yes",
				value: false,
			},
		],
	},
	{
		title: "Output Background colour",
		name: "output_background_colour",
		help: "Try #333333, rgba(255,255,255,0.5) or 'transparent'.",
		category: "Control & Output",
		type: "input",
		colourPicker: true,
		placeholder: "transparent",
	},
	{
		title: "Show cursor on Output",
		name: "output_cursor_show",
		help: "This will hide your mouse cursor on all outputs and remove the 'Save PNG' dropdown menu.",
		category: "Control & Output",
		type: "select",
		options: [
			{
				label: "Show",
				value: "auto",
			},
			{
				label: "Hide",
				value: "none",
			},
		],
	},
	{
		title: "Draw on screen",
		name: "output_draw_on_screen",
		help: "When enabled, use your mouse to draw on the output. Tip: Use 'C' to clear a drawing, Use 'U' to undo your last line.",
		category: "Drawing",
		type: "select",
		defaultSelected: false,
		options: [
			{
				label: "Enable",
				value: true,
			},
			{
				label: "Hidden",
				value: false,
			},
		],
	},
	{
		title: "Draw on screen - Colour",
		name: "output_draw_on_screen_colour",
		help: "Use Hex values like #333333.",
		category: "Drawing",
		type: "input",
		colourPicker: true,
		placeholder: "#333333",
	},
	{
		title: "Draw on screen - Brush Radius",
		name: "output_draw_on_screen_size",
		help: "Choose the size of the brush when drawing.",
		category: "Drawing",
		type: "select",
		defaultSelected: 6,
		options: [
			{
				label: "Extra small",
				value: 1,
			},
			{
				label: "Small",
				value: 3,
			},
			{
				label: "Medium",
				value: 6,
			},
			{
				label: "Large",
				value: 8,
			},
			{
				label: "Extra large",
				value: 10,
			},
		],
	},
	{
		title: "Google Maps API Key",
		name: "google_maps_api_key",
		help: "API key generated from the Google Maps developer console.",
		helpLink: "https://docs.h2r.graphics/graphics/map",
		category: "Google Maps",
		type: "input",
		inputType: "password",
		placeholder: "ABCD1234EFGH5678",
	},
	{
		title: "YouTube API key",
		name: "youtube_api_key",
		help: "API key generated from the YouTube developer console.",
		helpLink:
			"https://docs.h2r.graphics/control/data-source/youtube-live-chat#getting-a-youtube-api-key",
		category: "Data sources",
		type: "input",
		inputType: "password",
		placeholder: "ABCD1234EFGH5678",
	},
	{
		title: "YouTube channel name",
		name: "youtube_channel_name",
		help: "This is used to highlight chat messages that mention you.",
		category: "Data sources",
		type: "input",
		placeholder: "My channel name",
	},
	{
		title: "YouTube 'Member' translation",
		name: "youtube_member_language",
		help: "Used as a label next to a member of your YouTube channel.",
		category: "Data sources",
		type: "input",
		placeholder: "Member",
	},
	{
		title: "YouTube auto-refresh interval",
		name: "youtube_polling_interval",
		help: "How often the app checks for new messages.",
		category: "Data sources",
		type: "select",
		options: [
			{
				label: "10 seconds (Good for short streams)",
				value: 10000,
			},
			{
				label: "30 seconds",
				value: 30000,
			},
			{
				label: "60 seconds (Best for longer streams)",
				value: 60000,
			},
		],
	},
	{
		title: "Import",
		buttonText: "Import settings",
		name: "import_all_settings",
		help: "Import settings from another computer.",
		category: "Import/Export",
		type: "button",
	},
	{
		title: "Export",
		buttonText: "Export all settings",
		name: "export_all_settings",
		help: "Export all settings to move to another computer.",
		category: "Import/Export",
		type: "button",
	},
	{
		title: "User ID",
		name: "sync_user_id",
		help: "User ID provided by H2R Graphics Cloud.",
		category: "Cloud",
		type: "input",
		placeholder: "1234567890",
	},
	{
		title: "Cloud Sync Token",
		name: "sync_user_token",
		help: "Your token provided by H2R Graphics Cloud.",
		category: "Cloud",
		type: "input",
		inputType: "password",
		placeholder: "ABCD1234EFGH5678",
	},
	// {
	// 	title: "Cloud Q&A Token",
	// 	name: "interactions_user_token",
	// 	help: "Your token provided by H2R Graphics Cloud.",
	// 	category: "Cloud",
	// 	type: "input",
	// 	inputType: "password",
	// 	placeholder: "ABCD1234EFGH5678",
	// },
];
